/**
 * Minifigs 2.0 - Apply torso image overlay to product media gallery items
 *
 *
 * @author Benjamin Wilson <benjamin.wilson@four.agency>
 * @package Joi Polloi
 */

const searchTorsoMediaOverlays = () => {
    const imageOverlays = Array.from(document.querySelectorAll('.imageOverlaySearch'));
    if (!imageOverlays || imageOverlays.length === 0) return;

    imageOverlays.forEach((overlay) => {
        const gridItem = overlay.closest('.grid__item');
        if (!gridItem) return;

        const overlaySrc = overlay.dataset.overlay;
        let name = 'default';
        if (overlaySrc.includes('Colour') || overlaySrc.includes('Light')) {
            name = 'Colour';
        } else if (overlaySrc.includes('Dark')) {
            name = 'Dark';
        }

        gridItem.style.setProperty(`--overlay-${name}`, `url(${overlaySrc})`);
    });

    const gridItems = Array.from(document.querySelectorAll('.grid__item'));
    const variantIds = gridItems.map((item) => item.dataset.productVariantId);

    const getMetafield = async () => {
        try {
            const resp = await fetch('/api/2025-04/graphql.json', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/graphql',
                    'Access-Control-Origin': '*',
                    'X-Shopify-Storefront-Access-Token': 'e14901ef020f42eff2b10fbed13e6e18',
                },
                body: query(variantIds),
            });

            return await resp.json();
        } catch (err) {
            console.log('Fetch Error :-S', err);
        }
    };

    getMetafield().then((res) => {
        const variants = res.data.nodes;
        gridItems.forEach((item) => {
            const variant = variants.find(
                (v) => v?.id === `gid://shopify/ProductVariant/${item.dataset.productVariantId}`
            );

            if (variant && variant.torsoOverlayValue) {
                item.dataset.overlaytheme = variant.torsoOverlayValue?.value;
                const cardMedia = item.querySelector('.card__media');

                if (variant.torsoOverlayValue?.value === 'Dark') {
                    cardMedia.classList.add('torsoOverlayValue__dark');
                } else if (variant.torsoOverlayValue?.value === 'Light') {
                    cardMedia.classList.add('torsoOverlayValue__colour');
                }
            }
        });
    });
};

export default searchTorsoMediaOverlays;

const query = (variantIds) => {
    const formattedIds = variantIds.map((id) => `gid://shopify/ProductVariant/${id}`);
    return `{
        nodes(ids: ${JSON.stringify(formattedIds)}) {
            ... on ProductVariant {
                id
                torsoOverlayValue: metafield(
                        namespace: "custom"
                        key: "torso_overlay"
                    ) {
                        value
                    }
            }
        }
    }`;
};
